import TomSelect from "tom-select/dist/js/tom-select.base";
import 'tom-select/dist/css/tom-select.css';
import '../../scss/Components/Select-Custom.scss';
import {bodyOverflow} from "../Helpers/Body";


class Select {

    constructor() {
        this.customSelect();
        this.rechargeSelect();
    }

    customSelect() {
        const select = document.querySelectorAll('.js--select');

        if (!select) {
            return;
        }

        for (let i = 0; i < select.length; i++) {

            new TomSelect(select[i], {
                hideSelected: true,
                create: false,
                render: {
                    no_results: null,
                }
            });
        }
    }

    rechargeSelect() {

        let selecttom = [];

        document.addEventListener('click', (evt) => {
            if (evt.target.classList.contains('rc-radio__input')) {
                const selectRecharge = document.querySelectorAll('.rc_widget__option__plans__dropdown');
                evt.preventDefault();

                if (selecttom.length !== 0) {
                    return;
                }
                for (let i = 0; i < selectRecharge.length; i++) {
                    selecttom[i] =  new TomSelect(selectRecharge[i], {
                        hideSelected: true,
                        create: false,
                        render: {
                            no_results: null,
                        },
                        onInitialize: function () {
                            const line = document.querySelector('.custom-select .line');
                            const arrow = document.querySelector('.custom-select .arrow');
                            if (!line && !arrow) {
                                return;
                            }
                            this.wrapper.insertAdjacentElement("afterend", line.cloneNode(true));
                            this.wrapper.insertAdjacentElement("afterend", arrow.cloneNode(true));
                        }
                    });
                }

            }
        })

    }

}

document.addEventListener("DOMContentLoaded", function (event) {
    new Select();
});
